__turbopack_context__.v({
  "base": "button-module-scss-module__yOrGDq__base",
  "base__isLoading": "button-module-scss-module__yOrGDq__base__isLoading",
  "base__isSuccess": "button-module-scss-module__yOrGDq__base__isSuccess",
  "base__withFocus": "button-module-scss-module__yOrGDq__base__withFocus",
  "buttonSuccessIcon": "button-module-scss-module__yOrGDq__buttonSuccessIcon",
  "font_l": "button-module-scss-module__yOrGDq__font_l",
  "font_m": "button-module-scss-module__yOrGDq__font_m",
  "font_s": "button-module-scss-module__yOrGDq__font_s",
  "font_xs": "button-module-scss-module__yOrGDq__font_xs",
  "shade_danger": "button-module-scss-module__yOrGDq__shade_danger",
  "shade_dark": "button-module-scss-module__yOrGDq__shade_dark",
  "size_full": "button-module-scss-module__yOrGDq__size_full",
  "size_lg": "button-module-scss-module__yOrGDq__size_lg",
  "size_md": "button-module-scss-module__yOrGDq__size_md",
  "size_s": "button-module-scss-module__yOrGDq__size_s",
  "variant_filled": "button-module-scss-module__yOrGDq__variant_filled",
  "variant_ghost": "button-module-scss-module__yOrGDq__variant_ghost",
  "variant_outlined": "button-module-scss-module__yOrGDq__variant_outlined",
});
